<template>
  <div class="giftBox">
    <el-tabs v-if="Lib.checkPower('beauty-3-ckgkzpjl2',2)" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="可使用" name="first">
        <ul class="giftTop">
          <li v-for="(item,index) in topList" :key="index" :class="activeType==index?'giftActive':''" @click="selectGiftType(item,index)">{{ item.name }}({{ item.number }})</li>
        </ul>
        <ul v-if="clientGiftList.length > 0" v-infinite-scroll="load" class="giftCard" style="overflow:auto">
          <li v-for="(cardItem,cardIndex) in clientGiftList" :key="cardIndex">
            <h1>{{ cardItem.name }}</h1>
            <p>
              <span v-if="cardItem.remaining!=0&&cardItem.remaining!=null||cardItem.countLimitType==3">数量：{{ cardItem.remaining }}</span>
              <span>到期时间：{{ cardItem.expireTime?cardItem.expireTime:'永久有效' }}</span>
            </p>
            <p>赠送门店：{{ cardItem.shopName }}</p>
            <div class="tis">{{ cardItem.giftType===1?'项目':cardItem.giftType===2?'产品':'套餐' }}</div>
          </li>
        </ul>
        <div v-else style="color: #999;text-align: center;font-size: 14px;margin-top:40px">暂无记录</div>
        <el-pagination v-if="clientGiftList.length > 0" background :current-page.sync="currentPage" :page-size="15" layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="已使用" name="second">
        <ul class="giftTop">
          <li v-for="(item,index) in topList" :key="index" :class="activeType==index?'giftActive':''" @click="selectGiftType(item,index)">{{ item.name }}({{ item.number }})</li>
        </ul>
        <ul v-if="clientGiftList.length > 0" class="giftCard">
          <li v-for="(cardItem,cardIndex) in clientGiftList" :key="cardIndex">
            <h1>{{ cardItem.name }}</h1>
            <p>到期时间：{{ cardItem.expireTime?cardItem.expireTime:'永久有效' }}</p>
            <p v-if="cardItem.useDetailList ? cardItem.useDetailList.length > 0 ? true : false : false">
              使用时间：{{ cardItem.lastUseTime }}
              <el-popover placement="top-start" trigger="click" popper-class="giftPopover" width="350">
                <el-timeline class="giftTimeliner" color="#0bbd87">
                  <el-timeline-item
                    v-for="(activity, index) in cardItem.useDetailList"
                    :key="index"
                  >
                    <h4>使用时间：{{ activity.useTime }}</h4>
                    <p>使用门店：{{ activity.useShopName }}</p>
                    <p>订单号：{{ activity.orderCode }}</p>
                  </el-timeline-item>
                </el-timeline>

                <span slot="reference" class="details">使用详情</span>
              </el-popover>
            </p>
            <div class="tis">{{ cardItem.giftType===1?'项目':cardItem.giftType===2?'产品':'套餐' }}</div>
          </li>
        </ul>
        <div v-else style="color: #999;text-align: center;font-size: 14px;margin-top:40px">暂无记录</div>
        <el-pagination v-if="clientGiftList.length > 0" background :current-page.sync="currentPage" :page-size="15" layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="已失效" name="third">
        <ul class="giftTop">
          <li v-for="(item,index) in topList" :key="index" :class="activeType==index?'giftActive':''" @click="selectGiftType(item,index)">{{ item.name }}({{ item.number }})</li>
        </ul>
        <ul v-if="clientGiftList ? clientGiftList.length > 0 ? true : false : false" class="giftCard">
          <li v-for="(cardItem,cardIndex) in clientGiftList" :key="cardIndex">
            <h1>{{ cardItem.name }}</h1>
            <p>
              <span v-if="cardItem.remaining!=0&&cardItem.remaining!=null||cardItem.countLimitType==3">数量：{{ cardItem.remaining }}</span>
              <span>到期时间：{{ cardItem.expireTime?cardItem.expireTime:'永久有效' }}</span>
            </p>
            <p>赠送门店：{{ cardItem.shopName }}</p>
            <div class="tis">{{ cardItem.giftType===1?'项目':cardItem.giftType===2?'产品':'套餐' }}</div>
          </li>
        </ul>
        <div v-else style="color: #999;text-align: center;font-size: 14px;margin-top:40px">暂无记录</div>
        <el-pagination v-if="clientGiftList.length > 0" background :current-page.sync="currentPage" :page-size="15" layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import { clientGifts, } from '../api';

export default {
  data() {
    return {
      activeName: 'first', // 选中的tabs
      activeType: 0, // 选中赠品类型
      tableType: 1, // 查询类型 1 可使用 2已使用 3已失效
      giftType: 0, // 赠品类型 0全部 1项目 2赠品 3套餐
      phoneSearchVal: '', // 顾客手机号
      currentPage: 1, // 页码
      total: 1, // 列表总数
      topList: [{ name: '全部', giftType: 0, }, { name: '项目', giftType: 1, }, { name: '产品', giftType: 2, }, { name: '套餐', giftType: 3 }],
      giftData: {}, // 赠品信息
      clientGiftList: [], // 赠送列表
      // pageSize: 1
    };
  },
  activated() {
    this.phoneSearchVal = window.sessionStorage.customerPhone;
    this.getClientGifts();
  },

  methods: {
    load() {
      this.getClientGifts();
    },
    // 获取列表
    getClientGifts() {
      const data = {
        mainId: window.sessionStorage.mainId,
        tableType: this.tableType,
        giftType: this.giftType,
        phone: this.phoneSearchVal,
        currentPage: this.currentPage,
        pageSize: 15,
      };
      clientGifts(data).then((res) => {
        if (res.code === 0) {
          this.topList.forEach((value, index) => {
            if (index === 0) {
              value.number = res.data.allCount;
            } else if (index === 1) {
              value.number = res.data.itemCount;
            } else if (index === 2) {
              value.number = res.data.productCount;
            } else if (index === 3) {
              value.number = res.data.packageCount;
            }
          });
          this.giftData = res.data;
          const dataPage = res.data.page;
          this.total = dataPage.total;
          this.clientGiftList = dataPage.records;
        }
      });
    },
    handleClick(tab) {
      this.clientGiftList = [];
      this.tableType = parseInt(tab.index, 10) + parseInt('1', 10);
      this.giftType = 0;
      this.currentPage = 1;
      this.activeType = 0;
      this.getClientGifts();
    },
    // 选择赠品类型
    selectGiftType(item, index) {
      this.clientGiftList = [];
      this.giftType = item.giftType;
      this.currentPage = 1;
      this.activeType = index;
      this.getClientGifts();
    },

    handleSizeChange(val) {
      this.currentPage = val;
      this.getClientGifts();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getClientGifts();
    },
  },
};
</script>

<style lang="less" scoped>
.giftTop{
  display: flex;
  margin-top: 5px;
  li{
    display: inline-block;
    background-color: #ffffff;
    border: 1px solid #E4E7ED;
    color: #303133;
    cursor: pointer;
    background: #fff;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    padding:5px 15px;
    font-size: 12px;
    border: 1px solid #bfcbd9;
    border-color: #c4c4c4;
    border-radius: 25px;
    margin-right: 10px;
  }
}
.giftCard{
  cursor: pointer;
  margin-top: 15px;
  // height: 500px;
  li{
    position: relative;
    display: inline-table;
    margin-bottom: 10px;
    margin-right: 18px;
    width: 270px;
    padding:0 15px;
    background: #F8F8F8;
    opacity: 1;
    border-radius: 5px;
    height: 120px;
    h1{
      font-size: 16px;
      color: #333333;
      padding: 15px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 236px;
    }
    p{
      font-size: 14px;
      color: #666666;
      padding-bottom: 15px;
      span:nth-child(2){
        padding-left: 10px;
      }
      .details{
        color: #0071FE;
        float: right;
      }
    }
  }
  .tis{
    position: absolute;
    width: 49px;
    height: 23px;
    background: #66D131;
    opacity: 1;
    border-radius: 0px 5px 0px 5px;
    font-size: 12px;
    line-height: 16px;
    color: #FFFFFF;
    top: 0;
    right: 0;
    text-align: center;
    line-height: 23px;
}
}
.giftPopover {
}
.giftTimeliner{
  padding: 20px 15px 0 15px!important;
  h4{
    font-size: 15px;
    color: #303133;
  }
  p{
    margin-top: 8px;
    font-size: 13px;
    color: #909399;
  }
}
</style>
